<template>
  <div class="card">
    <!--begin::Chart-->
    <apexchart
      class="statistics-widget-3-chart card-rounded-bottom"
      :options="options"
      :series="series"
      :height="280"
      type="bar"
    ></apexchart>
    <!--end::Chart-->
  </div>
</template>

<script>
/*eslint-disable */

export default {
  props: ["data"],
  data() {
    return {
      options: {},
      series: [],
    };
  },

  watch: {
    data: function (value) {
      this.updateChart();
    },
    "$i18n.locale": function () {
      this.updateChart();
    },
  },

  created() {
    this.updateChart();
  },

  methods: {
    updateChart() {
      const series = [
        {
          name: this.$t("bulletinStatistics.equalsOrExceeds16"),
          data: this.data.map((level) => level.gte16),
          color: "#26a0fc",
        },
        {
          name: this.$t("bulletinStatistics.between15And1599"),
          data: this.data.map((level) => level.between15And16),
          color: "#00e365",
        },
        {
          name: this.$t("bulletinStatistics.between10And1499"),
          data: this.data.map((level) => level.between10And14),
          color: "#feb019",
        },
        {
          name: this.$t("bulletinStatistics.lessThan10"),
          data: this.data.map((level) => level.lt10),
          color: "#ff6178",
        },
      ];

      const levels = this.data.map((level) => level.level + this.$t("bulletinStatistics.levelSuffix"));

      // get max student number for each level
      const students = this.data.map((level) => level.students);

      this.updateOptions(levels, students);
      this.updateSeries(series);
    },

    updateSeries(serie) {
      this.series = serie;
    },
    updateOptions(types, students) {
      this.options = {
        chart: {
          height: 300,
          type: "bar",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          sparkline: {
            enabled: false,
          },
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true | '<img src="/static/icons/reset.png" width="20">',
              customIcons: [],
            },
            export: {
              csv: {
                filename: this.$t("bulletinStatistics.schoolStatistics"),
                columnDelimiter: ",",
                headerCategory: this.$t("bulletinStatistics.level"),
                headerValue: "value",
              },
              svg: {
                filename: this.$t("bulletinStatistics.schoolStatistics"),
              },
              png: {
                filename: this.$t("bulletinStatistics.schoolStatistics"),
              },
            },
            autoSelected: "zoom",
          },
        },
        dataLabels: {
          enabled: true,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
            dataLabels: {
              position: "top",
            },
          },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          type: "string",
          categories: types,
          labels: {
            style: {
              fontSize: "13px",
              fontWeight: 500,
            },
          },
        },
        yaxis: [
          {
            labels: {
              formatter: function (val) {
                return val ? val.toFixed(0) : 0;
              },
            },
            min: 0,
          },
        ],
        tooltip: {
          style: {
            fontSize: "12px",
          },
          y: {
            formatter: (val, data) => {
              return this.$t("bulletinStatistics.student") + " " + val + "/" + students[data.dataPointIndex];
            },
          },
        },
        markers: {
          strokeWidth: 1,
        },
      };
    },
  },
};
</script>
